<div id="scrn-table">
  <div id="scrn-cell">
    <div id="scrn-p" *ngIf="showForm">
      <header id="scrn-h">
        <div class="myunichoices-logo">
          <img src="assets/images/myunichoices-logo.png" alt="MyUniChoices" />
        </div>
        <div class="subtitle-strap">{{ locale.introText }}</div>
      </header>

      <p>{{ locale.introParagraph }}</p>
      <form
        id="scrn-c"
        [formGroup]="loginForm"
        (ngSubmit)="login(loginForm.value)"
        novalidate="novalidate"
      >
        <div class="form-control">
          <input
            (click)="onClickInput()"
            type="email"
            class="input-control"
            placeholder="{{ locale.emailPlaceholder }}"
            [value]="username"
            [formControl]="loginForm.controls['username']"
          />
        </div>
        <div class="form-control">
          <input
            (click)="onClickInput()"
            type="{{ passwordType }}"
            class="input-control show-pad"
            placeholder="{{ locale.passwordPlaceholder }}"
            formControlName="password"
            [formControl]="loginForm.controls['password']"
          />
          <span
            ><a (click)="togglePassword()">{{
              showPassword ? locale.hidePasswordText : locale.showPasswordText
            }}</a></span
          >
        </div>
        <div class="form-control">
          <button type="submit" class="input-control button" [disabled]="formSubmitted">
            {{ locale.loginButtonText }}
          </button>
        </div>
        <div class="forgotton-pwd">
          <a routerLink="/forgotten-login" class="underline">{{ locale.forgottenLoginLinkText }}</a>
        </div>
      </form>
      <footer id="scrn-f" *ngIf="canRegister">
        <div class="sign-up">
          {{ locale.noAccountText }} <a href="{{ paymentPortal }}">{{ locale.registerLinkText }}</a>
        </div>
      </footer>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/account/login/login.component.html